import { render, staticRenderFns } from "./WithdrawUSDT.vue?vue&type=template&id=c22ff442&scoped=true"
import script from "./WithdrawUSDT.vue?vue&type=script&lang=js"
export * from "./WithdrawUSDT.vue?vue&type=script&lang=js"
import style0 from "./WithdrawUSDT.vue?vue&type=style&index=0&id=c22ff442&prod&lang=css"
import style1 from "./WithdrawUSDT.vue?vue&type=style&index=1&id=c22ff442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22ff442",
  null
  
)

export default component.exports